
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * ExecutionDecision enum
 */
class ExecutionDecision {
  /**
   * Initialize enum with a given value
   * @param {ExecutionDecision|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof ExecutionDecision) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!ExecutionDecision}
   * @param {!ExecutionDecision} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ExecutionDecision)) {
      throw new TypeError('Instance of ExecutionDecision is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!ExecutionDecision}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!ExecutionDecision}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === ExecutionDecision.EXECUTED.value) {
      return 'EXECUTED'
    }
    if (this.value === ExecutionDecision.REJECTED.value) {
      return 'REJECTED'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!ExecutionDecision}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!ExecutionDecision}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!ExecutionDecision} Created enum
   */
  static fromObject (other) {
    return new ExecutionDecision(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
ExecutionDecision.EXECUTED = new ExecutionDecision(0 + 0)
// noinspection PointlessArithmeticExpressionJS
ExecutionDecision.REJECTED = new ExecutionDecision(0 + 1)

export { ExecutionDecision };

/**
 * Fast Binary Encoding ExecutionDecision field model
 */
class FieldModelExecutionDecision extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelExecutionDecision}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelExecutionDecision}
   * @param {ExecutionDecision=} defaults Default value, defaults is new ExecutionDecision()
   * @returns {!ExecutionDecision} Result value
   */
  get (defaults = new ExecutionDecision()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new ExecutionDecision(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelExecutionDecision}
   * @param {!ExecutionDecision} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelExecutionDecision };
